import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Store } from "lucide-react";
import { IStore } from "@/interfaces/merchant.interfaces";
import { BUSINESS_TYPE } from "@/constants/merchant.constant";

interface ViewStoreModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  store: IStore | null;
  merchant?: { businessType?: string };
}

function isOfflineStore(
  store: IStore,
  merchant?: { businessType?: string }
): boolean {
  return (
    merchant?.businessType === BUSINESS_TYPE.OFFLINE ||
    !!(
      store.contactNumber ||
      store.email ||
      store.mapLink ||
      store.storeImageUri
    )
  );
}

export function ViewStoreModal({
  open,
  onOpenChange,
  store,
  merchant,
}: ViewStoreModalProps) {
  if (!store) return null;

  const offline = isOfflineStore(store, merchant);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Store className="h-5 w-5" />
            Store Details
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div>
            <h3 className="text-lg font-semibold">
              {store?.storeName || "N/A"}
            </h3>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs mt-2 bg-purple-100 text-purple-800">
              {offline ? "Offline" : "Online"}
            </span>
          </div>

          <div className="space-y-3 pt-2">
            <div>
              <p className="text-sm font-medium">Address</p>
              <p className="text-sm text-muted-foreground">
                {store?.address || "—"}
              </p>
            </div>
            <div>
              <p className="text-sm font-medium">City</p>
              <p className="text-sm text-muted-foreground">
                {store?.city || "—"}
              </p>
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
